import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=5df24904&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrder.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=5df24904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df24904",
  null
  
)

export default component.exports